import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import moment from 'moment';
import validationEngine from 'devextreme/ui/validation_engine';

export class Utility {
    static ImageFileTypes = ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'svg', 'ico', 'tiff', 'tif', 'heic', 'heif', 'avif', 'webp'];
    static SalesTaxRate = 0.06;
    static Terms = [
        {
            name: 'Net 10',
            dayOffset: 10,
        },
        {
            name: 'Net 15',
            dayOffset: 15,
        },
        {
            name: 'Net 30',
            dayOffset: 30,
        },
    ];

    static isImage(fileName: string) {
        if (!fileName || !fileName.includes('.')) return false;

        const extension = fileName.split('.').pop();
        return Utility.ImageFileTypes.includes(extension);
    }

    static round(value: number, decimalPlaces: number = 0) {
        // negative numbers are rounded towards zero, which is wrong. To fix, convert value to positive, round, then convert back to negative
        //was not rounding a 0.5 correctly, added toFixed to correct  https://stackoverflow.com/questions/59480096/how-to-round-to-2-decimal-places-with-typescript
        return (Math.sign(value) * Math.round(Number((Math.abs(value) * Math.pow(10, decimalPlaces)).toFixed(decimalPlaces)))) / Math.pow(10, decimalPlaces);
    }

    static roundingTests() {
        this.roundingTest(589.675, 2, 589.68);
        this.roundingTest(22.9 * 25.75, 2, 589.68);
        this.roundingTest(0.005, 2, 0.01);
        this.roundingTest(-0.005, 2, -0.01);
        this.roundingTest(0.4999999999, 4, 0.5000);
        this.roundingTest(0.64999999999, 4, 0.6500);
        this.roundingTest(1/3, 4, 0.3330);
    }

    static roundingTest(value: number, decimalPlaces: number, expectedResult: number) {
        const actualResult = Utility.round(value, decimalPlaces);
        if (actualResult === expectedResult) console.log('Pass', { value, decimalPlaces, expectedResult, actualResult });
        else console.error('Fail', { value, decimalPlaces, expectedResult, actualResult });
    }

    // static checkRowDoubleClick(e): boolean {
    //     const component: any = e.component;

    //     const initialClick = () => {
    //         component.clickCount = 1;
    //         component.clickKey = e.key;
    //         component.clickDate = new Date();
    //         return false;
    //     };

    //     const doubleClick = () => {
    //         component.clickCount = 0;
    //         component.clickKey = 0;
    //         component.clickDate = null;
    //         return true;
    //     };

    //     if (!component.clickCount || component.clickCount !== 1 || component.clickKey !== e.key) {
    //         return initialClick();
    //     } else if (component.clickKey === e.key) {
    //         const now: any = new Date();
    //         if (now - component.clickDate <= 300) return doubleClick();
    //         else return initialClick();
    //     }
    // }

    static localToUtc(datetime: Date) {
        if (!datetime) return datetime;

        return moment(datetime).subtract(moment(datetime).utcOffset(), 'minutes').toDate();
    }

    static utcToLocal(datetime: Date) {
        if (!datetime) return datetime;
        else {
            return moment(datetime).add(moment(datetime).utcOffset(), 'minutes').toDate();
        }
    }

    static isAlphaNumeric(value) {
        // regex for alphanumeric only
        const re = /^[a-z0-9]+$/i;
        return !value || re.test(value);
    }

    static convertToAlphaNumeric(value: string): string {
        if (!value) return value;
        // regex for alphanumeric only
        const re = /[^a-z0-9]/gi;
        return value.replace(re, '');
    }

    static validateEmailAddresses(emails: string) {
        // regex that checks for comma separated emails. It does not allow for empty strings.
        const re = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/g;
        return re.test(emails);
    }

    static setMinLine(lines: any[]): number {
        let minId = (_.minBy(lines, 'id') as any).id;
        if (minId < 0) minId--;
        else minId = -1;
        return minId;
    }

    static toTimeOnly(date: Date) {
        return moment(date).format('HH:mm:ss');
    }

    static startOfDay(date?: Date) {
        if (!date) return date;
        return moment(date).startOf('day').toDate();
    }

    static valid(validationGroup: string) {
        const groupConfig = validationEngine.getGroupConfig(validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(validationGroup);
            return result.isValid;
        } else return false;
    }
}
